
"use strict";

import numberFormat from "../../common/number-format";
import leadingZeroes from "../../common/lead-zeroes";

const SVOD_TABLE = "2";
const TOTAL_VIDEO_SHARING = "3";

export default function renderViewingSummaryReportCSV(data, options) {

    if (!data.length) {
        return 'No data for this week yet';
    }

    const decimals = (parseInt(options.dataType) === 0) ? 0 : 2;

    const formatter = row => {
        const nullValueSymbol =
            (row.station_id === "Reporting Universe" || row.station_id === "Total TV") ? "" : "-";

        const minSec = `${row.avg_min}:${leadingZeroes(row.avg_sec)}`;

        return `"${row.station_name}",` +
            `"${row.monthly_reach_000 != null ? row.monthly_reach_000 : nullValueSymbol}",` +
            `"${Number(row.monthly_reach_percentage) >= 0 ? numberFormat(row.monthly_reach_percentage, decimals) : nullValueSymbol}",` +
            `"${Number(row.total_identified_viewing) >= 0 ? numberFormat(row.total_identified_viewing, 2) : nullValueSymbol}",` +
            `="${(Number(row.avg_min) >= 0 && Number(row.avg_sec) >= 0) ? minSec : nullValueSymbol}"`;

    };

    const standardRows = data
        .filter(row => row.table !== SVOD_TABLE && (options.includeHidden || row.table !== TOTAL_VIDEO_SHARING))
        .map(formatter);

    const SVODRows = data
        .filter(row => row.table === SVOD_TABLE)
        .map(formatter);

    const TVSRows = data
        .filter(row => row.table === TOTAL_VIDEO_SHARING)
        .map(formatter);

    const parts = [];

    // --- MAIN HEADER ---
    parts.push(
        `"Reach & time spent viewing", "Total Identified Viewing", "", , , `,
        `"All aged 4+", "Universe: UK TV & Broadband Households"`,
        `, "Monthly Reach 000s", "Monthly Reach %", "Share of 4", "Average Daily Mins"`,
        `"   ", "(TV Sets)", "(TV Sets)", "Screen TIV* %", "(MM:SS) (TV Sets)"`
    );

    // --- STANDARD TABLE ---
    if (standardRows.length) {
        parts.push(
            standardRows.join("\n"),
            "",
            ""
        );
    }

    // --- SVOD ---
    if (SVODRows.length) {
        parts.push(
            `, "Monthly Reach 000s", "Monthly Reach %", "Share of 4", "Average Daily Mins"`,
            `"   ", "(TV Sets)", "(TV Sets)", "Screen TIV* %", "(MM:SS) (TV Sets)"`,
            SVODRows.join("\n"),
            "",
            ""
        );
    }

    // --- TVS ---
    if (TVSRows.length) {
        parts.push(
            `, "Monthly Reach 000s", "Monthly Reach %", "Share of 4", "Average Daily Mins"`,
            `"   ", "(TV Sets)", "(TV Sets)", "Screen TIV* %", "(MM:SS) (TV Sets)"`,
            TVSRows.join("\n")
        );
    }

    return parts.join("\r\n");
}
